<template>
  <b-modal
    id="modal-1"
    size="sm"
    hide-header-close
    hide-footer
    title="Login"
    modal-class="login-modal-sm"
    @show="resetModal"
    ok-only
    no-stacking
  >
    <b-form data-vv-scope="login">
      <b-form-group label="">
        <b-form-radio-group>
          <b-form-radio
            v-model="picked"
            name="teacher-radios"
            value="Teacher"
            v-validate="'required'"
            >Teacher</b-form-radio
          >
          <b-form-radio
            v-model="picked"
            name="student-radios"
            value="Student"
            v-validate="'required'"
            >Student</b-form-radio
          >
        </b-form-radio-group>
        <div id="rating-feedback" v-if="showLoginError && !picked">
          <small style="color: #dc3545;font-size: .6em">
            Choose Student or Teacher
          </small>
        </div>
      </b-form-group>
      <b-form-group>
        <b-form-input
          v-model="email"
          placeholder="Username/Email*"
          class="logininput"
          v-validate="'required|email'"
          name="email"
          :class="{ 'is-invalid': errors.has('login.email') }"
          id="login-form-email"
        ></b-form-input>
        <b-form-invalid-feedback id="input-1-live-feedback">
          <small>{{ errors.first("login.email") }}</small>
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <b-form-input
          v-model="password"
          placeholder="Password*"
          class="logininput"
          type="password"
          name="password"
          id="login-form-password"
          :class="{ 'is-invalid': errors.has('login.password') }"
          v-validate="'required|min:8'"
          ref="password"
        ></b-form-input>
        <b-form-invalid-feedback id="input-3-live-feedback">
          <small>{{ errors.first("login.password") }}</small>
        </b-form-invalid-feedback>
      </b-form-group>
      <b-button
        variant="primary"
        class="login-btn-lg w-100"
        type="submit"
        @click.prevent="action('login')"
        >Login</b-button
      >
    </b-form>
    <p class="subtext">
      <b-link v-b-modal.modal-multi-2>Forgot Password</b-link>
    </p>
    <facebook-button :buttonText="buttonText"></facebook-button>
    <p class="subtext">
      Don't have an account?
      <b-link to="/register" @click="$bvModal.hide('modal-1')"
        >Register Here</b-link
      >
    </p>
  </b-modal>
</template>

<script>
import { authenticationApi } from "../../services/authenticationApi";
import FacebookButton from "../buttons/FacebookButton";
import { store } from "../../store/store";
import { mapGetters } from "vuex";
import { adminAuthentication } from "../../services/adminApis/adminAuthentication";

export default {
  components: { FacebookButton },
  name: "login-modal",
  data() {
    return {
      email: "",
      password: "",
      role: "",
      showLoginError: false,
      buttonText: "Login with facebook",
      picked: "Student"
    };
  },
  computed: {
    ...mapGetters("events", [
      "getRedirectToDescription",
      "getRedirectToSubscription",
      "getFollowTeacher",
      "getAddReview"
    ])
  },
  methods: {
    action(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.showLoginError = false;
          this.login();
          this.$bvModal.hide("modal-1");
        } else {
          this.showLoginError = true;
        }
      });
    },
    login() {
      if (this.picked === "Teacher") this.role = "teacher";
      else this.role = "student";
      const userData = {
        email: this.email,
        password: this.password,
        role: this.role
      };
      authenticationApi
        .login(userData)
        .then(res => {
          this.$bvToast.toast("Login Successful", {
            title: "Login",
            autoHideDelay: 500,
            appendToast: true
          });
            if (this.role === "teacher") {
                this.$router.push("/admin");
            }else {
                if (this.getRedirectToDescription) {
                    store.dispatch("events/setRedirectToDescription", false);
                    store.dispatch("events/setShowLiveVideo", true);
                } else if (this.getRedirectToSubscription) {
                    store.dispatch("events/setRedirectToSubscription", true);
                } else if (this.getFollowTeacher) {
                    store.dispatch("events/setFollowTeacher", false);
                } else if (this.getAddReview) {
                    store.dispatch("events/setAddReview", false);
                } else {
                    if (
                        this.$route.path === "/" ||
                        this.$route.path === "/register"
                    ) {
                        this.$router.push({
                            name: "userdashboard",
                            path: "/student/dashboard",
                            query: {
                                role: this.role
                            }
                        });
                    }
                }
                }
          store.dispatch("user/setUserRole", this.role);
        })
        .catch(e => {
          this.$bvToast.toast(`Login Failed ${e.body.message}`, {
            title: "Login",
            autoHideDelay: 500,
            appendToast: true
          });
        });
    },
    resetModal() {
      this.email = "";
      this.password = "";
      this.role = "";
      this.picked = "";
      this.showLoginError = false;
    }
  }
};
</script>

<style scoped></style>
